import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { debounce } from 'lodash';
import * as Yup from 'yup';

import TextInput from '../TextInput';

import { providersOperations } from '@evdy/web-redux/dist/lib/webPurchase/providers';

import styles from './FindProviders.module.scss';

import magnifyingIcon from '../../public/images/icons/magnifying_glass.svg';
import findProvidersHome from '../../public/images/find-provider-home.svg';

const { fetchProviders } = providersOperations;

const {
  'find-providers': findProvidersClass,
  'provider-section': providerSectionClass,
  'find-providers-home': findProvidersHomeClass,
  label: labelClass,
  input: inputClass
} = styles;

const FindProviders = ({ initialFormValue, isAuthedUser, isPreSelectedCompany }) => {
  const dispatch = useDispatch();
  const initialValues = {
    searchTerm: isPreSelectedCompany ? '' : !!initialFormValue ? initialFormValue : ''
  };
  const FormSchema = Yup.object().shape({
    searchTerm: Yup.string()
  });

  // debounce provider fetch 1/2 sec
  const handleProviderFetch = debounce(({ target: { value } }) => {
    if (value?.length > 2) dispatch(fetchProviders({ searchTerm: value, isAuthedUser }));
  }, 500);

  return (
    <div className={findProvidersClass}>
      <div className={providerSectionClass}>
        <img className={findProvidersHomeClass} src={findProvidersHome} alt="find-providers" />
        <h5>Find providers near you</h5>
      </div>
      <div className={providerSectionClass}>
        <Formik initialValues={initialValues} validationSchema={FormSchema}>
          {({ handleChange }) => (
            <TextInput
              label="Search by city, zip, or provider name"
              name="searchTerm"
              type="text"
              placeholder=""
              icon={magnifyingIcon}
              customLabelClass={labelClass}
              customInputClass={inputClass}
              onChange={e => {
                handleProviderFetch(e);
                handleChange(e);
              }}
            />
          )}
        </Formik>
      </div>
    </div>
  );
};

export default FindProviders;
